export function dispatch(emitter, type, payload, options) {
    const e = new CustomEvent(`theme.${type}`, Object.assign({
        bubbles: true,
        cancelable: true,
        detail: payload,
    }, options || {}));
    emitter.dispatchEvent(e);
    return e;
}
export function on(emitter, type, callback, options) {
    emitter.addEventListener(`theme.${type}`, callback, options);
}
export function off(emitter, type, callback, options) {
    emitter.removeEventListener(`theme.${type}`, callback, options);
}
export function dispatchGlobal(type, payload) {
    return dispatch(document.documentElement, type, payload);
}
export function onGlobal(type, callback, options) {
    on(document.documentElement, type, callback, options);
}
export function offGlobal(type, callback, options) {
    off(document.documentElement, type, callback, options);
}
